module.exports = __webpack_public_path__ + "a5a3fdb8babec09f28a1e54f20674298.png";